import type { ManagedChatModel } from "./aiProviders";

export const MODEL_EXPERIMENT_MODELS: readonly ManagedChatModel[] = [
  "claude-opus-4-8",
  "claude-sonnet-5",
  "gpt-5.6-sol",
];

// Deterministic per-thread assignment (FNV-1a over the thread key — the
// branch id for workflow conversations, the chat id for personal chats) so a
// conversation keeps one model without storing the assignment.
export function assignedExperimentModel(
  threadKey: string,
  availableModels: readonly string[]
): ManagedChatModel | null {
  const candidates = MODEL_EXPERIMENT_MODELS.filter((model) =>
    availableModels.includes(model)
  );
  if (candidates.length === 0) return null;
  let hash = 2166136261;
  for (let i = 0; i < threadKey.length; i++) {
    hash ^= threadKey.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return candidates[(hash >>> 0) % candidates.length]!;
}
